import { callWAReq } from '@src/utils/wa';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useState, useEffect } from 'react';

const WATracker = () => {
    const [isWATrackerLoaded, setIsWATrackerLoaded] = useState(false);
    const [isVisitorApiLoaded, setIsVisitorApiLoaded] = useState(false);
    const [isAdrumConfigLoaded, setIsAdrumConfigLoaded] = useState(false);
    const router = useRouter();

    // call trackPageView on routeChangeComplete
    useEffect(() => {
        const handleRouteChange = () => {
            callWAReq();
        };
        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);

    //adrum-config
    useEffect(() => {
        const window1 = window as any;
        window1['adrum-start-time'] = new Date().getTime();

        (function (config) {
            (function (xhr) {
                xhr.exclude = {
                    urls: [
                        {
                            pattern: '.*glassbox.*',
                            type: 'regex',
                        },
                    ],
                };
            })(config.xhr || (config.xhr = {}));
        })(window1['adrum-config'] || (window1['adrum-config'] = {}));

        (function (config) {
            config.appKey = process.env.NEXT_PUBLIC_ADRUM_APP_KEY;
            config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
            config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
            config.beaconUrlHttps = process.env.NEXT_PUBLIC_ADRUM_BEACON_URL;
            config.xd = { enable: false };
            config.spa = {
                spa2: true,
            };
        })(window1['adrum-config'] || (window1['adrum-config'] = {}));
        setIsAdrumConfigLoaded(true);
    }, []);

    return (
        <>
            <Script
                src={process.env.NEXT_PUBLIC_VISITORAPI_SCRIPT_SRC}
                type='text/javascript'
                onLoad={() => {
                    setIsVisitorApiLoaded(true);
                }}
            />
            {isVisitorApiLoaded && (
                <Script
                    type='text/javascript'
                    src={process.env.NEXT_PUBLIC_WA_TRACKER_SCRIPT_SRC}
                    onLoad={() => {
                        setIsWATrackerLoaded(true);
                    }}
                />
            )}
            {isWATrackerLoaded && (
                <Script
                    type='text/javascript'
                    src={process.env.NEXT_PUBLIC_WA_TRACKER_CONFIG_SCRIPT_SRC}
                    onLoad={() => {
                        callWAReq();
                    }}
                />
            )}
            <Script type='text/javascript' src={process.env.NEXT_PUBLIC_GLASSBOX_SCRIPT_SRC} />
            {isAdrumConfigLoaded && <Script src={process.env.NEXT_PUBLIC_ADRUM_SCRIPT_SRC} />}
        </>
    );
};

export default WATracker;
